import React from 'react';

import Badge, { BadgeStyle } from '../badge/Badge';

type BadgeListProps = {
    className?: string;
    title?: string;
    badges: BadgeItemInterface[] | string[];
    badgeStyle?: BadgeStyle;
    badgeTextColor?: string;
    badgeBgColor?: string;
    badgeHoverable?: boolean;
    onBadgeClick?: (badgeId?: string, badgeTitle?: string) => void;
    leadingIcon?: React.JSX.Element;
};

export interface BadgeItemInterface {
    id: string;
    name: string;
    href?: string;
}

function BadgeList(props: BadgeListProps): React.JSX.Element {
    const {
        className,
        title,
        badges,
        badgeStyle,
        badgeTextColor,
        badgeBgColor,
        badgeHoverable,
        onBadgeClick,
        leadingIcon
    } = props;

    return (
        <div className={`${className} flex flex-col`}>
            {title && <h5 className="uppercase font-montserrat-semibold">{title}</h5>}
            <div className="flex flex-row items-center space-x-8">
                {leadingIcon ? <div>{leadingIcon}</div> : null}
                <div className="flex flex-wrap gap-10 overflow-hidden overflow-ellipsis">
                    {badges &&
                        badges.map((badge, index) => (
                            <Badge
                                className="overflow-ellipsis overflow-hidden"
                                key={`badge#${index}`}
                                id={typeof badge === 'string' ? badge : badge.id}
                                name={typeof badge === 'string' ? badge : badge.name}
                                href={typeof badge === 'string' ? badge : badge.href}
                                textColor={badgeTextColor}
                                bgColor={badgeBgColor}
                                badgeStyle={badgeStyle || BadgeStyle.large}
                                hoverable={badgeHoverable}
                                onBadgeClick={onBadgeClick}
                            />
                        ))}
                </div>
            </div>
        </div>
    );
}

export default BadgeList;
